export const binanceChainId = 56

export const moonRiverChainId = 1285
